module.exports = __webpack_public_path__ + "img/The-Gambia.4206f7d3.png";